import { render, staticRenderFns } from "./TagsView.vue?vue&type=template&id=ebdae84c&scoped=true"
import script from "./TagsView.vue?vue&type=script&lang=js"
export * from "./TagsView.vue?vue&type=script&lang=js"
import style0 from "./TagsView.vue?vue&type=style&index=0&id=ebdae84c&prod&lang=stylus"
import style1 from "./TagsView.vue?vue&type=style&index=1&id=ebdae84c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebdae84c",
  null
  
)

export default component.exports